import { vm } from "@/main.js";
import firebase from "firebase/app";
import "firebase/auth";
import IndexedDB from "@/helpers/IndexedDB.js";
import Router from "@/router/index.js";

/**
 * Permite ejecutar una descarga de texto a un archivo de texto plano
 * @param {string} text - Es una cadena de string que sera anexsada al archivo.
 * @param {string} nameFile - nombre del archivo
 */
const downloadFile = (text, nameFile) => {
  const url = "data:text/plain;charset=utf-8," + encodeURIComponent(JSON.stringify(text));
  var link = document.createElement("a");
  link.setAttribute("download", nameFile);
  link.href = url;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

/**
 * Despliega una notificación la cual permite notificar al usuario el resultado de algún evento.
 * @param {string} title - Le permite aclarar el tipo de notificación que se realiza.
 * @param {string} text - una breve descripción informando al usuario lo que ha pasado.
 * @param {string} color - Especifica de forma visual el tipo de notificación (primary, success, danger, warning, dark)
 * @param {string} position - Posiciona la notificación
 * @param {string} icon - Tipo de icono a mostrar en la notificación
 * @param {string} iconPack - de que paquete proviene el icono por defecto es feather
 */
const notify = (title, text, color = "success", position = "top-right", icon = null, iconPack = "feather") => {
  vm.$vs.notify({ title, text, color, position, icon, iconPack });
};

/**
 * Bloquea ciertas partes de los elementos html para indicar que se esta realizando una ejecución en proceso.
 * @param {string} type - (default, point, radius, corners, border, sound, material)
 * @param {string} container - id del elemento html donde se ejecutara la capa del loading ejemplo "#container-loading"
 * @param {string} color - Es un valor exadecimal
 *
 */
const loading = (type = "default", container = null, color = null) => {
  vm.$vs.loading({
    type,
    color,
    container
  });
};

/**
 * Cierre del loading
 * @param {string} container - id del elemento html que contiene el loading en ejecución.
 */
const closeLoding = (container = null) => {
  if (container !== null) return vm.$vs.loading.close(`#${container} > .con-vs-loading`);
  return vm.$vs.loading.close();
};

/**
 * Permite visualizar un dialogo de confirmación
 * @param {object} object - Objeto con ciertas propiedades para el diagolo de confirmación.
 * @param {string} object.title - Título para el encabezado.
 * @param {string} object.text - Texto informativo apra el cuerpo.
 * @param {Function} object.accept - Función para el evento aceptar.
 * @param {Function} object.cancel - Función para el evento cancelar.
 * @param {string} object.color - Es un valor exadecimal.
 * @param {string} object.color - Es un valor exadecimal.
 * @param {string} object.type - Indica el tipo de dialogo por defecto es confirm.
 * @param {string} object.acceptText - Texto personalizado que tendra el botón aceptar.
 * @param {string} object.cancelText - Texto personalizado que tendra el botón cancelar.
 * @param {string} object.templete - indica si el texto sera un texto plano o un templete personalizado con etiquetas html.
 */
const confirm = ({
  title,
  text,
  accept,
  cancel = null,
  color = "danger",
  type = "confirm",
  acceptText = "Aceptar",
  cancelText = "Cancelar",
  templete = false
} = {}) => {
  vm.$vs.dialog({
    type: type,
    color: color,
    title: title,
    text: templete ? "" : text,
    accept: accept,
    cancel: cancel,
    acceptText,
    cancelText
  });

  if (templete) {
    setTimeout(() => {
      const element = document.querySelector("body div.vs-dialog-text");
      element.innerHTML = text;
    }, 100);
  }
};

/**
 * Cierra sesión con firebase y limpia el almacenamiento local del navegador.
 */
const logout = async () => {
  await firebase.auth().signOut();
  ClearStorages();
};

/**
 * Limpia el almacenamiento local del navegador.
 */
const ClearStorages = async () => {
  await IndexedDB.truncate("users");
  // If JWT login
  if (localStorage.getItem("accessToken")) {
    localStorage.removeItem("accessToken");
  }

  localStorage.removeItem("userInfo");
  Router.push("/pages/login");
};

export { notify, downloadFile, confirm, loading, closeLoding, logout };
